<template>
    <div>
        <div class="modal fade" id="projectdetails" tabindex="-1" aria-labelledby="projectdetails" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="addCoach">Project Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="dashboard-wrapper">

                        <!-- ─── CARD 1: PROJECT BALANCE HEADER ─── -->
                        <div class="metrics-card card-shadow">
                            <div class="header-inline-row">
                                <div class="label-with-icon">
                                <span class="muted-label">Project Balance</span>
                                <span class="icon-eye-action">👁️</span>
                                </div>
                                <div class="toggle-switch-wrapper">
                                <span class="toggle-text-label">Auto-Fund</span>
                                <label class="switch-container">
                                    <input type="checkbox" checked />
                                    <span class="slider-toggle-round"></span>
                                </label>
                                </div>
                            </div>

                            <div class="balance-display-row">
                                <h1 class="main-currency-value">
                                ₦19,200,000<span class="decimal-fraction">.00</span>
                                </h1>
                            </div>

                            <div class="footer-inline-row">
                                <span class="target-footnote-label">Target amount: ₦24,000,000</span>
                                <div class="metric-indicator-pill">
                                <span class="info-circle-badge">ⓘ</span>
                                <span class="pill-performance-text">PI 60% ↑</span>
                                </div>
                            </div>
                        </div>

                        <!-- ─── CARD 2: GOAL METRICS TRACKER ─── -->
                        <div class="metrics-card card-shadow">
                        <div class="header-inline-row">
                            <h3 class="section-component-title">Goal</h3>
                            <span class="interval-pill-active">Monthly</span>
                        </div>

                        <!-- Linear Tracking Progress bar layout -->
                        <div class="progress-bar-wrapper">
                            <div class="progress-track-bg">
                            <div class="progress-fill" :style="{ width: progressPercent + '%' }"></div>
                            </div>
                            <span class="progress-floating-label">{{ progressPercent }}%</span>
                        </div>

                        <div class="progress-bounds-row">
                            <span class="bound-val">₦2,400,000</span>
                            <span class="bound-val">₦19,200,000</span>
                        </div>

                        <p class="insight-summary-footnote">You're 80% away from your goal</p>
                        </div>

                        <!-- ─── BANNER: CYCLIC ALERT INFORMATION ─── -->
                        <div class="info-alert-banner">
                        <div class="alert-icon-circle">ⓘ</div>
                        <p class="alert-message-content">
                            Next funding cycle starts <span class="highlighted-date">Nov 5, 2025</span>. Ensure your SAFE wallet has sufficient balance.
                        </p>
                        </div>

                        <!-- ─── CARD 3: FUNDING PLAN BREAKDOWN MATRIX ─── -->
                        <div class="metrics-card card-shadow no-padding-bottom">
                            <h3 class="section-component-title padding-bottom-md">Funding Plan</h3>

                            <div class="matrix-table-row border-bottom-divider">
                                <span class="funding_plan">Project Amount</span>
                                <span class="fund_value">₦24,000,000</span>
                            </div>

                            <div class="matrix-table-row border-bottom-divider">
                                <span class="funding_plan">Payment Plan</span>
                                <span class="fund_value">₦2,400,000 / Monthly</span>
                            </div>

                            <div class="matrix-table-row border-bottom-divider">
                                <span class="funding_plan">Project Duration</span>
                                <span class="fund_value">12 Months</span>
                            </div>

                            <div class="matrix-table-row padding-vertical-lg">
                                <span class="funding_plan">Start Date - End Date</span>
                                <span class="fund_value date-range-text">Nov 12, 2025 - Dec 12, 2026</span>
                            </div>
                        </div>

                    </div>

                    <div class="button-class container">
                        <button class="btn primaryBtn w-100" @click="closeModalFund()">Fund Project</button>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>




<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    components: {
        PageLoader,
    },
    props: {
        // Receive the data snapshot passed from parent
        projectData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            progressPercent: 50,
        };
    },
    created() {

    },
    mounted() {
        // console.log("Prject details in modal:", this.projectData)
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        closeModalFund() {
            console.log("close now open")
            $("#projectdetails")
            .removeClass("fade")
            .modal("hide");

            $("#fundproject")
            .addClass("fade")
            .modal("show");
            // this.projectModalData = { ...details };
        }
    }
};
</script>



<style scoped lang="scss">
.button-class {
    margin-bottom: 50px;
    .primaryBtn {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        height: 45px;
        outline: 0;
        box-shadow: none;
    }
}
.top-header-hold {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: center;
    }
}


.dashboard-wrapper {
  background-color: #f8fafc; /* Crisp architectural slate white background canvas */
  padding: 20px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* Base configuration parameters for all UI block frames */
.metrics-card {
  background-color: #ffffff;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.card-shadow {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.015); /* Light all-round shadow mapping */
}

.no-padding-bottom { padding-bottom: 0px; }
.padding-bottom-md { margin-bottom: 16px; }

/* Structural Row alignments rules */
.header-inline-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.footer-inline-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

/* Label details layout styling */
.label-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.muted-label {
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
  font-family: Lato;
}

.icon-eye-action {
  cursor: pointer;
  opacity: 0.6;
  font-size: 14px;
}

/* Custom platform checkbox slide switch configuration code */
.toggle-switch-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-text-label {
  color: #334155;
  font-size: 14px;
  font-weight: 500;
  font-family: Lato;
}

.switch-container {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch-container input { opacity: 0; width: 0; height: 0; }

.slider-toggle-round {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #cbd5e1;
  transition: .3s;
  border-radius: 24px;
  font-family: Lato;
}

.slider-toggle-round:before {
  position: absolute;
  content: "";
  height: 18px; width: 18px;
  left: 3px; bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
  font-family: Lato;
}

input:checked + .slider-toggle-round { background-color: #2563eb; } /* Primary interface blue */
input:checked + .slider-toggle-round:before { transform: translateX(20px); }

/* Financial Main Metric Text parameters */
.balance-display-row {
  margin: 12px 0;
}

.main-currency-value {
  font-size: 34px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.5px;
  font-family: Lato;
}

.decimal-fraction {
  color: #94a3b8; /* Faded fractional values match image design details */
  font-family: Lato;
}

.target-footnote-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  font-family: Lato;
}

/* Dynamic percentage indicator pill right footer side */
.metric-indicator-pill {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-circle-badge {
  color: #94a3b8;
  font-size: 12px;
}

.pill-performance-text {
  color: #16a34a; /* Vibrant Green upward financial movement code marker */
  font-weight: 600;
  font-size: 14px;
  font-family: Lato;
}

/* Card 2 Header layout definitions */
.section-component-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  font-family: Lato;
}

.interval-pill-active {
  background-color: #eff6ff;
  color: #2563eb;
  padding: 6px 14px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  font-family: Lato;
}

/* Progress bar alignment track styling configurations */
.progress-bar-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  margin-bottom: 12px;
}

.progress-track-bg {
  flex: 1;
  height: 12px;
  background-color: #f1f5f9;
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background-color: #2563eb;
  border-radius: 6px;
  font-family: Lato;
}

.progress-floating-label {
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  min-width: 32px;
  font-family: Lato;
}

.progress-bounds-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.bound-val {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  font-family: Lato;
}

.insight-summary-footnote {
  text-align: center;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  margin: 8px 0 0 0;
  font-family: Lato;
}

/* Soft blue cycle context alert strip configurations */
.info-alert-banner {
  background-color: #f0f7ff;
  border: 1px solid #e0f2fe;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: Lato;
}

.alert-icon-circle {
  background-color: #e0f2fe;
  color: #0284c7;
  width: 20px; height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
  font-family: Lato;
}

.alert-message-content {
  margin: 0;
  font-size: 14px;
  color: #0369a1;
  line-height: 1.5;
  font-weight: 500;
  font-family: Lato;
}

.highlighted-date {
  font-weight: 700;
}

/* Data Matrix block row lists layout configurations */
.matrix-table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.border-bottom-divider {
  border-bottom: 1px solid #f1f5f9;
}

.padding-vertical-lg { padding: 24px 0; }

.funding_plan {
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
  font-family: Lato;
  text-align: left;
}

.fund_value {
  color: #0f172a;
  font-weight: 700;
  font-size: 16px;
  font-family: Lato;
  text-align: right;
}

.date-range-text {
  font-weight: 600;
  color: #334155;
  font-family: Lato;
}
</style>